export default __webpack_public_path__ + "5772e28f1239a32a18e798d14c463afb.svg";